import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  content: {
    position: "relative",
    textAlign: "center",
    zIndex: 5,
    marginBottom: "20px"
  },
  invoice: {
    marginTop: "20px",
    width: "90%",
    borderRadius: "12px",
    position: "relative",
    transition: "filter 0.5s ease, box-shadow 1.5s ease", // Smooth transition for the filter and box-shadow effect
  },

  glowing: {
    boxShadow: "0 0 20px rgba(123, 207, 255, 0.8), 0 0 40px rgba(123, 207, 255, 0.6), 0 0 60px rgba(123, 207, 255, 0.4), 0 0 80px rgba(123, 207, 255, 0.2)", // Neon glow effect
    animation: "$glowAnimation 2s infinite alternate", // Animation for the glow effect
  },
  "@keyframes glowAnimation": {
    "0%": {
      boxShadow: "0 0 20px rgba(123, 207, 255, 0.4), 0 0 40px rgba(123, 207, 255, 0.3), 0 0 60px rgba(123, 207, 255, 0.2), 0 0 80px rgba(123, 207, 255, 0.1)",
    },
    "100%": {
      boxShadow: "0 0 20px rgba(123, 207, 255, 0.8), 0 0 40px rgba(123, 207, 255, 0.6), 0 0 60px rgba(123, 207, 255, 0.4), 0 0 80px rgba(123, 207, 255, 0.2)",
    },
  },
});
